import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_4 = { class: "header-right" }


interface Props {
  title?: string;
  subtitle?: string;
  variant?: 'simple' | 'complex';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionHeader',
  props: {
    title: { default: '' },
    subtitle: { default: '' },
    variant: { default: 'simple' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["section-header", [_ctx.variant, { 'has-subtitle': _ctx.subtitle }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "left", {}, () => [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
        (_ctx.subtitle)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "right")
    ])
  ], 2))
}
}

})